module.exports = __webpack_public_path__ + "img/9791196165833.b93b10f7.jpg";